import Grid from '@mui/material/Grid'
import Switch from '@mui/material/Switch'

import { CustomFieldType } from '../../../models/enums'
import { PracticeLocationFeeConfiguration } from '../../../models/v2/Practice'
import CustomField from '../../shared/custom-fields/CustomField'

const moduleName = 'appointment-settings-locations-list'

type Props = {
    configuration: PracticeLocationFeeConfiguration
}

const formatThresholdAsDollars = (threshold: number): string => {
    return `$${Number(threshold).toFixed(2)}`
}

const ConsentToChargeFields = ({ configuration }: Props) => {
    return (
        <>
            <Grid
                item={true}
                xs={12}
                sm={6}
                md={3}
                lg={2.3}
                xl={2.3}
                className={`${moduleName}__table-item details ${moduleName}__consent-to-charge`}
                style={{ borderBottom: 'none', paddingTop: 16 }}
            >
                <label className={`${moduleName}__input-label`}>Consent to Charge</label>
                <div className={`${moduleName}__consent-to-charge-switch`}>
                    <Switch
                        data-testid="consent-to-charge-switch"
                        checked={configuration.consent_to_charge}
                        disabled={true}
                        size="small"
                    />
                </div>
            </Grid>
            <Grid
                item={true}
                xs={12}
                sm={6}
                md={3}
                lg={2.3}
                xl={2.3}
                className={`${moduleName}__table-item details ${moduleName}__consent-to-charge`}
                style={{ borderBottom: 'none', paddingTop: 16 }}
            >
                <label className={`${moduleName}__input-label`}>Consent to Charge Amount</label>
                <div
                    className={`${moduleName}__consent-to-charge-amount`}
                    data-testid="consent-to-charge-threshold-field"
                >
                    <CustomField
                        customFieldType={CustomFieldType.INPUT}
                        value={formatThresholdAsDollars(configuration.consent_to_charge_threshold)}
                        disabled={true}
                    />
                </div>
            </Grid>
        </>
    )
}

export default ConsentToChargeFields
